import './NewParcel.css'

import { Button, Modal } from 'react-bootstrap'
import React, { useState } from 'react'

import { axiosWithPostUrlEncoded as axios } from 'config/axios.js'
import { getParcelSaved } from 'api/ispyb.js'
import qs from 'qs'
import { useSelector } from 'react-redux'

const NewParcel = ({ shippingId, proposalName, onReload, handleClose }) => {
  const user = useSelector(state => state.user)
  const [code, setCode] = useState('')

  const handleSave = async event => {
    event.preventDefault()

    const saveData = {
      code,
      transportValue: '',
      storageLocation: '',
      comments: '',
      shippingId: shippingId,
    }

    await axios.post(getParcelSaved(user, proposalName, shippingId), qs.stringify(saveData))

    setCode('')
    onReload()
    handleClose()
  }

  return (
    <>
      <Modal show onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Parcel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSave}>
            <div>
              <label className="labelnewparcel" htmlFor="code">
                Name:
              </label>
              <input type="text" onChange={e => setCode(e.target.value)} id="code" />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" disabled={!code.length} onClick={handleSave}>
            Save
          </Button>
          <Button bsStyle="default" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default NewParcel
